export default function handleGenerateHarmoniousColors(amount: number): string[] {
    const colorsArray: string[] = [];

    // Cor base inicial (aleatória)
    let baseHue = Math.floor(Math.random() * 360); // 0-360 para HSL
    const saturation = 70; // Saturação fixa (0 a 100)
    const lightness = 50; // Luminosidade fixa (0 a 100)

    for (let i = 0; i < amount; i++) {
        const hue = (baseHue + i * (360 / amount)) % 360; // Distribui as tonalidades uniformemente
        colorsArray.push(hslToHex(hue, saturation, lightness));
    }

    return colorsArray;
}

// Função auxiliar para converter HSL para Hex
function hslToHex(h: number, s: number, l: number): string {
    const a = s / 100;
    const b = l / 100;
    const c = a * Math.min(b, 1 - b);
    const hueToRgb = (n: number) => {
        const k = (n + h / 30) % 12;
        const x = b - c * Math.max(-1, Math.min(k - 3, Math.min(9 - k, 1)));
        return Math.round(255 * x).toString(16).padStart(2, '0'); // Converte para hexadecimal
    };
    return `#${hueToRgb(0)}${hueToRgb(8)}${hueToRgb(4)}`;
}
